var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameramarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-54.7%",
    y: "-54.7%",
    width: "209.4%",
    height: "209.4%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    transform: "translate(7 5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#154273",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4 13.414l-1.85 1.754c0 1.249-.217 2.418-.55 2.418V13.26c0-.333-.285-.604-.637-.604H19.55L16.984 10.2a.692.692 0 0 0-.487-.199H11c-.331 0-.6.255-.6.569 0 .314.269.569.6.569h5.222l.511 1.517H9.437c-.352 0-.637.27-.637.604v.155H7.194a.417.417 0 0 0-.424-.38h-.34a.417.417 0 0 0-.424.38H6V16.069h.006c.016.211.197.38.424.38h.34a.418.418 0 0 0 .424-.38H8.8v4.327c0 .334.285.604.637.604h11.926c.352 0 .637-.27.637-.604v-1.672h.8l1.6 1.138H26v-6.448h-1.6zm-8 6.069h-5.6v-3.035h5.6v3.035z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameramarker);
export default __webpack_public_path__ + "static/media/cameramarker.541fb8e63819c4d09fd33819b20dbba4.svg";
export { ForwardRef as ReactComponent };